<template>
  <div class="c-box">
    <a-card
      style="width: 100%"
      :bordered="false"
      :tab-list="tabList"
      :active-tab-key="roleCode"
      @tabChange="(roleCode) => onTabChange(roleCode, 'roleCode')"
    >
      <p v-if="roleCode === 'school-role'">
        <table-view
          :columns="schoolTableColumns"
          type="学校"
          :data="datasources"
          :pagination="pagination"
          :loading="loading"
          ref="schoolModel"
          @showAddPop="showAddPop"
          @deleteApply="deleteApply"
          @editInfo="showEditPop"
          @search="search"
          @getLxApplyApplylist="getDatalist"
          @resetPasswords="resetPasswords"
        ></table-view>
      </p>
      <p v-else-if="roleCode === 'audit-role'">
        <table-view
          :columns="expertTableColumns"
          type="审核员"
          :data="datasources"
          :pagination="pagination"
          :loading="loading"
          ref="expertModel"
          @search="search"
          @showAddPop="showAddPop"
          @deleteApply="deleteApply"
          @editInfo="showEditPop"
          @getLxApplyApplylist="getDatalist"
          @resetPasswords="resetPasswords"
        ></table-view>
      </p>
      <p v-if="roleCode === 'teacher-role'">
        <template v-if="$store.state.role == 'school-role'">
          <table-view
            :columns="teacherTableColumns"
            type="教师"
            :data="datasources"
            :pagination="pagination"
            :loading="loading"
            ref="schoolModel"
            @showAddPop="showAddPop"
            @deleteApply="deleteApply"
            @editInfo="showEditPop"
            @search="searchTeach"
            @getLxApplyApplylist="getTeachlist"
            @resetPasswords="resetPasswords"
          ></table-view>
        </template>
        <template v-else>
          <table-view
            :columns="teacherTableColumns"
            type="教师"
            :data="datasources"
            :pagination="pagination"
            :loading="loading"
            ref="schoolModel"
            @showAddPop="showAddPop"
            @deleteApply="deleteApply"
            @editInfo="showEditPop"
            @search="search"
            @getLxApplyApplylist="getDatalist"
            @resetPasswords="resetPasswords"
          ></table-view>
        </template>
      </p>
    </a-card>
    <a-modal v-model="visible" :title="modalTitle" :afterClose="afterClose">
      <div class="mtb10">
        <span class="color-C73630">*</span>账号
        <span style="color: red">( 注：密码默认Mm_258369 )</span>
      </div>
      <a-input
        placeholder="请设置登录账号"
        :disabled="!isAdd"
        :maxLength="100"
        v-model="modalData.username"
      />
      <p v-if="emptyUName" :class="emptyUName ? 'warnColor' : ''">
        账号不能为空
      </p>
      <p v-if="existUName" :class="existUName ? 'warnColor' : ''">
        该账号已存在
      </p>

      <div class="mtb10"><span class="color-C73630">*</span>名称</div>
      <a-input
        :maxLength="100"
        placeholder="请设置账号名称"
        v-model="modalData.realname"
      />
      <p v-if="emptyLName" :class="emptyLName ? 'warnColor' : ''">
        名称不能为空
      </p>
      <div v-if="$store.state.role != 'school-role'">
        <div class="mtb10"><span class="color-C73630">*</span>所属部门</div>
        <a-select
          style="width: 100%"
          v-model="modalData.orgCode"
          @change="changeValue"
          show-search
          option-filter-prop="children"
          :filter-option="filterOption"
        >
          <a-select-option
            :value="item.orgCode"
            v-for="(item, index) in sslist"
            :key="index"
            >{{ item.departName }}</a-select-option
          >
        </a-select>
      </div>
      <p v-if="emptyorgcode" :class="emptyorgcode ? 'warnColor' : ''">
        所属部门不能为空
      </p>
      <div class="mtb10">电话</div>
      <a-input
        placeholder="请设置账号电话"
        :maxLength="11"
        v-model="modalData.phone"
        @blur="isCorrectphone"
        onkeyup="value=value.replace(/[^\d]/g,'')"
      />
      <!--      <p v-if="emptyPhone" :class="emptyPhone ? 'warnColor' : ''">-->
      <!--        电话不能为空-->
      <!--      </p>-->
      <p v-if="formatPhone" :class="formatPhone ? 'warnColor' : ''">
        *电话号码格式不正确
      </p>
      <!--      <p v-if="existPhone" :class="existPhone ? 'warnColor' : ''">-->
      <!--        电话号码已存在-->
      <!--      </p>-->
      <div
        v-if="roleCode === 'school-role' && $store.state.role != 'school-role'"
      >
        <div class="mtb10">类型</div>
        <a-select
          style="width: 100%"
          @change="handleChange"
          v-model="modalData.schoolType"
        >
          <a-select-option
            v-for="(item, index) in schoolTypeList"
            :key="index"
            :value="item.type"
          >
            {{ item.title }}
          </a-select-option>
        </a-select>
      </div>
      <div
        v-if="roleCode === 'school-role' && $store.state.role != 'school-role'"
      >
        <div class="mtb10"><span class="color-C73630">*</span>省</div>
        <a-select
          style="width: 100%"
          @change="handleChangeP"
          v-model="modalData.province"
          show-search
          option-filter-prop="children"
          :filter-option="filterOption"
        >
          <a-select-option
            :value="item.code"
            v-for="(item, index) in plist"
            :key="index"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </div>
      <p v-if="emptyprovince" :class="emptyprovince ? 'warnColor' : ''">
        省不能为空
      </p>
      <div
        v-if="roleCode === 'school-role' && $store.state.role != 'school-role'"
      >
        <div class="mtb10"><span class="color-C73630">*</span>市</div>
        <a-select
          style="width: 100%"
          @change="handleChangeC"
          v-model="modalData.city"
          show-search
          option-filter-prop="children"
          :filter-option="filterOption"
        >
          <a-select-option
            :value="item.code"
            v-for="(item, index) in clist"
            :key="index"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </div>
      <p v-if="emptycity" :class="emptycity ? 'warnColor' : ''">市不能为空</p>
      <!-- 教师负责工作室 -->
      <!-- <div v-if="$store.state.role == 'school-role'">
        <div class="mtb10">负责工作室</div>
        <a-select
          style="width: 100%"
          v-model="modalData.studioModules"
          show-search
          option-filter-prop="children"
          :filter-option="filterOption"
          mode="multiple"
          allowClear
        >
          <a-select-option
            :value="item.title"
            v-for="(item, index) in studioList"
            :key="index"
            >{{ item.title }}</a-select-option
          >
        </a-select>
      </div> -->

      <!-- 教师负责品牌 -->
      <!-- <div v-if="$store.state.role == 'school-role'">
        <div class="mtb10">负责品牌</div>
        <a-select
          style="width: 100%"
          v-model="modalData.brandModules"
          show-search
          option-filter-prop="children"
          :filter-option="filterOption"
          mode="multiple"
          allowClear
        >
          <a-select-option
            :value="item.title"
            v-for="(item, index) in brandList"
            :key="index"
            >{{ item.title }}</a-select-option
          >
        </a-select>
      </div> -->

      <template slot="footer">
        <a-button style="background: #2155b5; color: #fff" @click="handleOk"
          >保存</a-button
        >
      </template>
    </a-modal>
    <!-- 确认移除 -->
    <a-modal
      v-model="isDelete"
      :confirm-loading="confirmLoading"
      @ok="deleteHandle"
      @cancel="deleteCancelHandle"
      text
      cancelText="取消"
      okText="确认"
    >
      <p>确认移除本条账户数据？</p>
    </a-modal>
  </div>
</template>

<script>
import { getAction } from "@/api/index";
import tableView from "./userTableView";
import { STUDIO_LIST, BRAND_LIST } from "@/utils/commonSections";

import {
  lxAddUser,
  lxEditUser,
  lxDeleteUser,
  userLxList,
  userCheck,
  resetPasswords,
  teachLxList,
} from "../../api/index";

export default {
  name: "",
  components: { tableView },
  props: {},
  data() {
    return {
      studioList: STUDIO_LIST,
      brandList: BRAND_LIST,
      tabList: [
        {
          key: "school-role",
          tab: "学校管理",
        },
        {
          key: "audit-role",
          tab: "审核员管理",
        },
      ],
      tabList1: [
        {
          key: "teacher-role",
          tab: "教师管理",
        },
      ],
      schoolTableColumns: [
        {
          title: "序号",
          dataIndex: "sequenceNumber",
          id: "sequenceNumber",
          align: "center",
          width: 70,
        },
        {
          title: "账号",
          dataIndex: "username",
          id: "username",
          align: "center",
          scopedSlots: { customRender: "username" },
          width: 150,
        },
        {
          title: "名称",
          dataIndex: "realname",
          id: "realname",
          align: "center",
          scopedSlots: { customRender: "realname" },
          width: 200,
        },
        {
          title: "省",
          dataIndex: "province_dictText",
          id: "province_dictText",
          align: "center",
          width: 100,
          // scopedSlots: { customRender: "realname" },
        },
        {
          title: "市",
          dataIndex: "city_dictText",
          id: "city_dictText",
          align: "center",
          // scopedSlots: { customRender: "realname" },
          width: 100,
        },
        {
          title: "所属部门",
          dataIndex: "orgCode_dictText",
          id: "orgCode_dictText",
          align: "center",
          width: 160,
          // scopedSlots: { customRender: "realname" },
        },
        {
          title: "联系电话",
          dataIndex: "phone",
          id: "phone",
          align: "center",
          width: 120,
        },
        {
          title: "类型",
          dataIndex: "schoolType_dictText",
          id: "schoolType_dictText",
          align: "center",
          width: 150,
        },
        {
          title: "操作",
          id: "action",
          align: "center",
          width: 284,
          fixed: "right",
          scopedSlots: { customRender: "action" },
        },
      ],
      expertTableColumns: [
        {
          title: "序号",
          dataIndex: "sequenceNumber",
          id: "sequenceNumber",
          align: "center",
          width: 70,
        },
        {
          title: "账号",
          dataIndex: "username",
          id: "username",
          align: "center",
          scopedSlots: { customRender: "username" },
          width: 150,
        },
        {
          title: "名称",
          dataIndex: "realname",
          id: "realname",
          align: "center",
          scopedSlots: { customRender: "realname" },
          width: 240,
        },
        {
          title: "所属部门",
          dataIndex: "orgCode_dictText",
          id: "orgCode_dictText",
          align: "center",
          width: 160,
          // scopedSlots: { customRender: "realname" },
        },
        {
          title: "联系电话",
          dataIndex: "phone",
          id: "phone",
          align: "center",
          width: 120,
        },
        {
          title: "操作",
          id: "action",
          align: "center",
          width: 284,
          fixed: "right",
          scopedSlots: { customRender: "action" },
        },
      ],
      datasources: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10, //每页中显示10条数据
      },
      modalData: {
        username: "",
        realname: "",
        phone: "",
        province: "",
        city: "",
        area: "",
        schoolType: "ZZ",
        orgCode: "",
        studioModules: [],
        brandModules: [],
      },
      schoolTypeList: [
        { type: "GZ", title: "高职院校" },
        { type: "ZZ", title: "中职院校" },
        { type: "JG", title: "技工学校" },
        { type: "BK", title: "职业本科" },
      ],
      visible: false,
      isAdd: true, // 新增 true 修改 false
      modalTitle: "",
      isDelete: false,
      confirmLoading: false,
      userId: "",
      roleCode: "school-role",
      loading: true,
      emptyUName: false, //账号是否为空
      existUName: false, //账号是否存在
      emptyLName: false, //名称是否为空
      emptyPhone: false, //电话是否为空
      formatPhone: false, //电话格式是否正确
      existPhone: false, //电话是否存在
      emptyprovince: false,
      emptycity: false,
      emptyarea: false,
      emptyorgcode: false,
      plist: [],
      clist: [],
      alist: [],
      sslist: [],
      teacherTableColumns: [
        {
          title: "序号",
          dataIndex: "sequenceNumber",
          id: "sequenceNumber",
          align: "center",
          width: 70,
        },
        {
          title: "账号",
          dataIndex: "username",
          id: "username",
          align: "center",
          scopedSlots: { customRender: "username" },
          // width:150,
        },
        {
          title: "名称",
          dataIndex: "realname",
          id: "realname",
          align: "center",
          scopedSlots: { customRender: "realname" },
          width: 200,
        },
        {
          title: "联系电话",
          dataIndex: "phone",
          id: "phone",
          align: "center",
          width: 120,
        },
        {
          title: "操作",
          id: "action",
          align: "center",
          width: 284,
          scopedSlots: { customRender: "action" },
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    console.log(this.$store.state.role, "角色");
    if (this.$store.state.role == "school-role") {
      this.tabList = this.tabList1;
      this.roleCode = "teacher-role";
      this.getTeachlist({
        current: 1,
        pageSize: 10,
      });
      return;
    }
    this.getDatalist({
      current: 1,
      pageSize: 10,
    });
  },
  methods: {
    search(cs) {
      this.getDatalist({
        current: 1,
        pageSize: 10,
        realname: cs.realname,
        orgCode: cs.orgCode,
      });
    },
    searchTeach(cs) {
      console.log("cs");
      this.getTeachlist({
        current: 1,
        pageSize: 10,
        realname: cs.realname,
        orgCode: cs.orgCode,
      });
    },
    getpp() {
      getAction("/sys/sysDepart/departList", {}).then((res) => {
        if (res.code == 200) {
          // console.log(res);
          this.sslist = res.result;
        }
      });
    },
    changeValue() {
      this.emptyorgcode = false;
    },
    handleChangeP(value) {
      this.getcjlist(value);
      this.emptyprovince = false;
    },
    handleChangeC(value) {
      this.modalData.area = "";
      this.emptycity = false;
      this.getajlist(value);
    },
    handleChangeQ() {
      this.emptyarea = false;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getsjlist(type) {
      getAction("/infrastructure/cnArea/list?parent=0", {}).then((res) => {
        if (res.code == 200) {
          // console.log(res);
          this.plist = res.result.records;
          this.modalData.province = res.result.records[0].code;
          // 新增时默认选择第一个省份
          if (type === "add") {
            this.getcjlist(this.modalData.province);
          }
        }
      });
    },
    getcjlist(id) {
      getAction("/infrastructure/cnArea/list", { parent: id }).then((res) => {
        if (res.code == 200) {
          //              console.log(res);
          this.clist = res.result.records;
        }
      });
    },
    getajlist(id) {
      getAction("/infrastructure/cnArea/list", { parent: id }).then((res) => {
        if (res.code == 200) {
          console.log(res);
          this.alist = res.result.records;
        }
      });
    },
    // 切换学校/专家
    onTabChange(key, type) {
      this[type] = key;
      (this.pagination = {
        total: 0,
        current: 1,
        pageSize: 10, //每页中显示10条数据
      }),
        this.getDatalist(this.pagination);
    },
    // 新增 - 显示
    showAddPop(type) {
      this.modalTitle = "新增" + type;

      if (this.roleCode === "school-role") {
        this.getsjlist("add");
      }
      if (this.roleCode !== "teacher-role") {
        this.modalData.schoolType = "ZZ";
        this.getpp();
      } else {
        this.modalData.schoolType = "";
      }
      // 添加以下代码：初始化工作室和品牌数组
      // if (this.$store.state.role == "school-role") {
      //   this.modalData.studioModules = []; // 初始化为空数组
      //   this.modalData.brandModules = []; // 初始化为空数组
      // }
      this.isAdd = true;
      this.visible = true;
    },
    // 修改 - 显示 - 数据回显
    showEditPop(row) {
      this.modalData.username = row.username;
      this.modalData.realname = row.realname;
      this.modalData.phone = row.phone;
      // 负责工作室 字符串转数组回显
      if (row.studioModules && row.studioModules !== "") {
        this.modalData.studioModules = row.studioModules.split(",");
      } else {
        this.modalData.studioModules = [];
      }
      // 负责品牌 字符串转数组回显
      // if (row.brandModules && row.brandModules !== "") {
      //   this.modalData.brandModules = row.brandModules.split(",");
      // } else {
      //   this.modalData.brandModules = [];
      // }

      if (this.roleCode === "school-role") {
        this.modalData.province = row.province;
        this.getsjlist("edit");
        this.getcjlist(this.modalData.province);
        this.modalData.city = row.city;
        this.getajlist(this.modalData.city);
        this.modalData.area = row.area;
      }
      if (this.roleCode !== "teacher-role") {
        this.modalData.schoolType = row.schoolType;
        this.getpp();
        this.modalData.orgCode = row.orgCode;
      }
      this.modalData.id = row.id;
      this.isAdd = false;
      this.visible = true;
    },

    // 新增或修改调用接口
    handleOk() {
      console.log(this.modalData, "handleOk");
      this.emptyUName = false;
      this.emptyLName = false;
      this.emptyPhone = false;
      this.formatPhone = false;
      this.existUName = false;
      this.existPhone = false;
      this.emptyprovince = false;
      this.emptycity = false;
      this.emptyarea = false;
      this.emptyorgcode = false;
      this.modalData.roleCode = this.roleCode;
      this.modalData.schoolType =
        this.roleCode === "audit-role" ? undefined : this.modalData.schoolType;
      let timestamp = new Date().getTime();
      let reg = /^1[3-9][0-9]{9}$/;
      if (this.modalData.username === "") {
        this.emptyUName = true;
      } else {
        this.emptyUName = false;
      }
      if (this.modalData.realname === "") {
        this.emptyLName = true;
      } else {
        this.emptyLName = false;
      }
      if (this.$store.state.role != "school-role") {
        if (this.modalData.orgCode === "") {
          this.emptyorgcode = true;
        } else {
          this.emptyorgcode = false;
        }
      }

      if (this.modalData.phone && this.modalData.phone !== "") {
        this.emptyPhone = false;
        let a = reg.test(this.modalData.phone);
        console.log("a", a);
        if (a) {
          this.formatPhone = false;
        } else {
          this.formatPhone = true;
        }
      }
      console.log("this.roleCode", this.roleCode, this.modalData);
      if (this.roleCode === "school-role") {
        if (this.modalData.province === "") {
          this.emptyprovince = true;
        } else {
          this.emptyprovince = false;
        }
        if (this.modalData.city === "") {
          this.emptycity = true;
        } else {
          this.emptycity = false;
        }
        // if (this.modalData.area === "") {
        //   this.emptyarea = true;
        // } else {
        //   this.emptyarea = false;
        // }
      }
      console.log(
        "this.emptyUName",
        this.emptyUName,
        "this.emptyLName",
        this.emptyLName,

        this.emptyorgcode,
        this.emptyprovince,
        this.emptycity,
        this.emptyarea
      );
      console.log("this.isAdd0", this.isAdd);
      if (
        this.emptyUName === false &&
        this.emptyLName === false &&
        this.emptyorgcode === false &&
        this.emptyprovince === false &&
        this.emptycity === false &&
        this.emptyarea === false &&
        // this.emptyPhone === false &&
        this.formatPhone === false
      ) {
        if (this.isAdd) {
          let obj = {
            _t: timestamp,
            tableName: "sys_user",
            fieldName: "username",
            fieldVal: this.modalData.username,
          };
          // 负责工作室 数组转字符串传参
          if (
            this.modalData.studioModules &&
            this.modalData.studioModules.length > 0
          ) {
            obj.studioModules = this.modalData.studioModules.join(",");
          }
          // 负责品牌 数组转字符串传参
          // if (
          //   this.modalData.brandModules &&
          //   this.modalData.brandModules.length > 0
          // ) {
          //   obj.brandModules = this.modalData.brandModules.join(",");
          // }
          console.log(this.modalData.studioModules, 8888);
          console.log(obj, 9999);

          userCheck(obj).then((res) => {
            // console.log(res)
            if (res.code == 200) {
              this.existUName = false;
              // let obj = {
              //   _t: timestamp,
              //   tableName: "sys_user",
              //   fieldName: "phone",
              //   fieldVal: this.modalData.phone,
              // };
              // userCheck(obj).then((res) => {
              // console.log(res)
              // if (res.code == 200) {
              this.existPhone = false;
              let params = {
                ...this.modalData,
              };
              // 负责工作室 数组转字符串传参
              if (
                this.modalData.studioModules &&
                this.modalData.studioModules.length > 0
              ) {
                params.studioModules = this.modalData.studioModules.join(",");
              } else {
                params.studioModules = "";
              }
              // 负责品牌 数组转字符串传参
              // if (
              //   this.modalData.brandModules &&
              //   this.modalData.brandModules.length > 0
              // ) {
              //   params.brandModules = this.modalData.brandModules.join(",");
              // } else {
              //   params.brandModules = "";
              // }
              lxAddUser(params).then((res) => {
                if (res.code === 200) {
                  this.$message.success(res.message);
                } else {
                  this.$message.error(res.message);
                }
                if (this.$store.state.role == "school-role") {
                  this.getTeachlist(this.pagination);
                } else {
                  this.getDatalist(this.pagination);
                }
                this.visible = false;
                this.$forceUpdate();
              });
              // } else {
              // this.existPhone = true;
              // }
              // });
            } else {
              this.existUName = true;
              // let obj = {
              //   _t: timestamp,
              //   tableName: "sys_user",
              //   fieldName: "phone",
              //   fieldVal: this.modalData.phone,
              // };
              // userCheck(obj).then((res) => {
              // console.log(res)
              // if (res.code == 200) {
              this.existPhone = false;
              // } else {
              // this.existPhone = true;
              // }
              // });
            }
          });
        } else {
          // let obj = {
          //   _t: timestamp,
          //   tableName: "sys_user",
          //   fieldName: "phone",
          //   fieldVal: this.modalData.phone,
          //   dataId: this.modalData.id,
          // };
          // userCheck(obj).then((res) => {
          //  console.log(res)
          // if (res.code == 200) {
          this.existPhone = false;
          let params = {
            ...this.modalData,
          };
          // 负责工作室 数组转字符串传参
          if (
            this.modalData.studioModules &&
            this.modalData.studioModules.length > 0
          ) {
            params.studioModules = this.modalData.studioModules.join(",");
          } else {
            params.studioModules = "";
          }
          // 负责品牌 数组转字符串传参
          // if (
          //   this.modalData.brandModules &&
          //   this.modalData.brandModules.length > 0
          // ) {
          //   params.brandModules = this.modalData.brandModules.join(",");
          // } else {
          //   params.brandModules = "";
          // }
          lxEditUser(params).then((res) => {
            if (res.code === 200) {
              this.$message.success(res.message);
            } else {
              this.$message.error(res.message);
            }
            if (this.$store.state.role == "school-role") {
              this.getTeachlist(this.pagination);
            } else {
              this.getDatalist(this.pagination);
            }
            this.visible = false;
            this.$forceUpdate();
          });
          // } else {
          // this.existPhone = true;
          // }
          // });
        }
      }
    },

    // 重置密码
    resetPasswords(row) {
      const _this = this;
      this.$confirm({
        title: `你确定初始 ${row.username} 的密码为'Mm_258369'吗`,
        cancelText: "取消",
        okText: "确定",
        onOk() {
          const data = {
            id: row.id,
          };
          resetPasswords(data).then((res) => {
            if (res.code == 200) {
              _this.$message.success(res.message);
            } else {
              _this.$message.error(res.message);
            }
          });
        },
        onCancel() {},
      });
    },
    // 移除
    deleteApply(id) {
      this.userId = id;
      this.isDelete = true;
    },
    deleteHandle() {
      let obj = { id: this.userId };
      lxDeleteUser(obj).then((res) => {
        if (res.code === 200) {
          this.isDelete = false;
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
        if (this.$store.state.role == "school-role") {
          this.getTeachlist(this.pagination);
        } else {
          this.getDatalist(this.pagination);
        }
        this.$forceUpdate();
      });
    },
    deleteCancelHandle() {
      this.visible = false;
    },

    // 列表
    getDatalist(pagination) {
      this.loading = true;
      let data = {
        roleCode: this.roleCode,
        pageNo: pagination.current,
        pageSize: pagination.pageSize,
        realname: pagination.realname ? pagination.realname : "",
        orgCode: pagination.orgCode ? pagination.orgCode : "",
      };
      userLxList(data).then((res) => {
        if (res.code == 200) {
          this.datasources = res.result.records;
          this.pagination.total = res.result.total;
          this.datasources.forEach((item, index) => {
            item.sequenceNumber = index + 1;
          });
        }
        this.loading = false;
      });
    },
    getTeachlist(pagination) {
      this.loading = true;
      let data = {
        roleCode: this.roleCode,
        pageNo: pagination.current,
        pageSize: pagination.pageSize,
        realname: pagination.realname ? pagination.realname : "",
        orgCode: pagination.orgCode ? pagination.orgCode : "",
      };
      teachLxList(data).then((res) => {
        if (res.code == 200) {
          this.datasources = res.result.records;
          this.pagination.total = res.result.total;
          this.datasources.forEach((item, index) => {
            item.sequenceNumber = index + 1;
          });
        }
        this.loading = false;
      });
    },

    // 添加页的关闭
    afterClose() {
      this.modalData = {
        username: "",
        realname: "",
        phone: "",
        schoolType: "市属中职",
        province: "",
        city: "",
        area: "",
        studioModules: [],
        brandModules: [],
      };
      this.emptyUName = false;
      this.emptyLName = false;
      this.emptyPhone = false;
      this.formatPhone = false;
      this.existUName = false;
      this.existPhone = false;
      this.emptyprovince = false;
      this.emptycity = false;
      this.emptyarea = false;
    },
    isCorrectphone() {
      var telStr = /^[1]([3-9])[0-9]{9}$/;
      if (this.modalData.phone === "") {
        this.emptyPhone = true;
        return false;
      } else {
        this.emptyPhone = false;
      }
      if (!telStr.test(this.modalData.phone)) {
        this.formatPhone = true;
        return false;
      } else {
        this.formatPhone = false;
      }
    },
    // 添加页的类型切换
    handleChange(value) {
      this.modalData.schoolType = value;
    },
  },
};
</script>

<style scoped lang="scss">
.c-box {
  height: 100%;
  overflow: auto;
}
.mtb10 {
  margin: 10px 0;
}
.color-C73630 {
  color: #2155b5;
  padding-right: 10px;
}
.warnColor {
  color: red;
  font-size: 14px;
}
/deep/ .ant-tabs-nav .ant-tabs-tab:hover,
/deep/ .ant-tabs-nav .ant-tabs-tab-active {
  color: #2155b5 !important;
}
/deep/ .ant-tabs-ink-bar {
  background-color: #2155b5 !important;
}
</style>
